var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPitchEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6143 0.751953L1.23926 7.30273C0.655273 7.63281 0.706055 8.49609 1.31543 8.75L4.89551 10.2227V12.8125C4.89551 13.5996 5.83496 13.9297 6.31738 13.3457L7.86621 11.4668L11.0654 12.7871C11.5479 12.9902 12.1064 12.6855 12.1826 12.1523L13.8076 1.56445C13.9092 0.904297 13.1982 0.396484 12.6143 0.751953ZM5.70801 12.8125V10.5781L7.0791 11.1367L5.70801 12.8125ZM11.3955 12.0508L6.13965 9.86719L11.2178 3.90039C11.3447 3.74805 11.1416 3.54492 10.9893 3.67188L4.51465 9.20703L1.64551 8.01367L13.0205 1.4375L11.3955 12.0508Z",
    fill: "#383838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitchEmpty);
export default __webpack_public_path__ + "static/media/pitch_empty.9638bc3b.svg";
export { ForwardRef as ReactComponent };